
export default function SoftwareSVG({className}) {
    return (
        <svg className={className} id="uuid-425a0da9-2f79-41d3-be8a-d38d9ac32b79" data-name="Schrift" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 489.14 439.28">
            <path d="m389.51,339.59v-199.92H99.63v199.92h289.88Zm-118.08-137.36l6.25-7.81,54.86,43.89-54.86,43.89-6.25-7.81,45.1-36.08-45.1-36.08Zm-13.91-17.58l9.47,3.21-35.38,104.11-9.47-3.21,35.38-104.11Zm-46.07,9.77l6.25,7.81-45.1,36.08,45.1,36.08-6.25,7.81-54.86-43.89,54.86-43.89Z" style="fill: #e4032e; stroke-width: 0px;"/>
            <path d="m99.63,99.69v29.99h289.88v-29.99H99.63Zm19.99,19.99h-10v-10h10v10Zm19.99,0h-10v-10h10v10Zm19.99,0h-10v-10h10v10Z" style="fill: #e4032e; stroke-width: 0px;"/>
        </svg>
    );
  }
  